module.exports = __webpack_public_path__ + "img/xuebitu.f2834c3c.jpg";